(function () {
    'use strict';

    angular.module('app')
        .factory('DivisaTipoExistenciaService', DivisaTipoExistenciaService);

    /* @ngInject */
    function DivisaTipoExistenciaService($resource) {
        return $resource('api/public/divisa/tipo-existencia', {}, {
            'get': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();
